import {
  IconFile,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypeXls,
  IconFileTypeZip,
} from '@tabler/icons-react'

import { IMAGE_FORMATS } from '@/config/constants/fileTypes'

const BASE_ASSET_URL = 'https://assets.buildpass.com.au'
const LEGACY_MARKUP_SUFFIX = '%20-%20markup' // due to a bug in the original markup URL generation where " - markup" was added AFTER the extension

export const isDocument = (url: string) => {
  const extension = extensionFromUrl(url).toLowerCase()
  const isImage = IMAGE_FORMATS.some((f) => extension === f.toLowerCase())

  return !isImage
}

export const extensionFromUrl = (url: string) => {
  try {
    if (url?.startsWith(BASE_ASSET_URL)) {
      const fullUrl = new URL(url)
      const innerUrl = fullUrl.pathname.slice(1) // remove the leading slash
      const parsedInnerUrl = new URL(decodeURIComponent(innerUrl)) // is encoded, so decode it
      return (
        parsedInnerUrl.pathname
          .split('.')
          .pop()
          .replace(LEGACY_MARKUP_SUFFIX, '') ?? ''
      )
    }

    return url.split('.').pop().toLowerCase() ?? '' // naive attempt
  } catch {
    return ''
  }
}

export const createDownloadLink = (fullUrl: string) =>
  decodeURIComponent(fullUrl.replace(`${BASE_ASSET_URL}/`, ''))

export const getDocumentIcon = (
  extension: string,
  size = 24,
  stroke?: number
) => {
  const ext = extension.toLowerCase()

  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return <IconFileTypeJpg size={size} stroke={stroke} />
    case 'png':
      return <IconFileTypePng size={size} stroke={stroke} />
    case 'pdf':
      return <IconFileTypePdf size={size} stroke={stroke} />
    case 'doc':
      return <IconFileTypeDoc size={size} stroke={stroke} />
    case 'docx':
      return <IconFileTypeDocx size={size} stroke={stroke} />
    case 'xls':
    case 'xlsx':
      return <IconFileTypeXls size={size} stroke={stroke} />
    case 'zip':
    case 'rar':
      return <IconFileTypeZip size={size} stroke={stroke} />
    default:
      return <IconFile size={size} stroke={stroke} />
  }
}
